import React, { useState } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import List, { ListItem } from "../../components/List";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";
import { isMoneyValid, normaliseMoney } from "../../shared/utils/moneyUtils";
import TextQuestion from "../../components/TextQuestion";

const Inheritance = ({ inheritance, onStepComplete }) => {
  const [formState, setFormState] = useState({
    inheritanceMoneyAmount: inheritance?.inheritanceMoneyAmount || "",
  });
  const [errors, setErrors] = useState({});
  const [errorMessages, setErrorMessages] = useState({
    inheritanceMoneyAmount: "Please fill this in",
  });

  const handleInputChange = (field) => (value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleValidation = () => {
    let newErrors = {};
    let newErrorMessages = { ...errorMessages };
    let formIsValid = true;

    if (!formState.inheritanceMoneyAmount) {
      newErrors.inheritanceMoneyAmount = true;
      formIsValid = false;
    }

    if (formState.inheritanceMoneyAmount !== "" && !isMoneyValid(formState.inheritanceMoneyAmount)) {
      newErrors.inheritanceMoneyAmount = true;
      newErrorMessages.inheritanceMoneyAmount = "Please enter a valid amount";
      formIsValid = false;
    }

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);
    return formIsValid;
  };

  const handleMoneyValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    setErrors((prev) => {
      let newErrors = { ...prev };

      if (!isBlur) {
        newErrors[field] = false;
      } else {
        if (!formState[field]) {
          newErrors[field] = true;
        } else if (!isMoneyValid(formState[field])) {
          newErrors[field] = true;
        }
      }

      return newErrors;
    });
    setErrorMessages((prev) => {
      let newErrorMessages = { ...prev };

      if (isBlur) {
        if (!formState[field]) {
          newErrorMessages[field] = "Please fill this in";
        } else if (!isMoneyValid(formState[field])) {
          newErrorMessages[field] = "Please enter a valid amount";
        }
      }

      return newErrorMessages;
    });
  };

  const saveInheritance = (event) => {
    event.preventDefault();

    if (handleValidation()) {
      onStepComplete({
        inheritance: {
          inheritanceMoneyAmount: normaliseMoney(formState.inheritanceMoneyAmount),
        },
      });
    }
  };

  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="Inheritance - a gift of money from someone who has died" removeTopPadding>
        <p>
          We need you to email the law firm that handled the probate (cc'ing in hello@juno.legal) – and ask them to
          confirm the inheritance and how much you received as a result.
        </p>
        <p>If the estate administration was not handled by a law firm, we need you to email us:</p>
        <List bullet>
          <ListItem>A copy of the Will showing your inheritance</ListItem>
          <ListItem>
            A copy of the estate accounts (this can just be a simple spreadsheet) showing the amount paid to you
          </ListItem>
        </List>
        <p>We'll send a reminder of what we need to your dashboard.</p>
        <TextQuestion
          question="How much of the inheritance will you use for your purchase?"
          value={formState.inheritanceMoneyAmount}
          valueEntered={handleInputChange("inheritanceMoneyAmount")}
          validate={handleMoneyValidation("inheritanceMoneyAmount")}
          validationError={errors.inheritanceMoneyAmount ? errorMessages.inheritanceMoneyAmount : null}
        />
        <Action onClick={saveInheritance}>Continue</Action>
      </Card>
      <Image src={imageCatAndHousePlant} />
    </React.Fragment>
  );
};

export default Inheritance;
